import { compositionReferenceRatio, compositionSnapshot } from './nutrition.ts';
import type { FoodEntry, Nutrients, NutritionCoverage } from './nutrition.ts';

export function nutritionTotals(entries: readonly FoodEntry[], unquantifiedRealizedCount = 0) {
  const keys = ['energyKcal','proteinG','carbohydrateG','fatG'] as const;
  const totals: Nutrients = {};
  const overflowed = new Set<keyof Nutrients>();
  let complete = entries.length > 0 && unquantifiedRealizedCount === 0;

  for (const entry of entries) {
    const ratio = compositionReferenceRatio(entry);
    const composition = compositionSnapshot(entry);
    if (ratio === undefined || composition.state !== 'KNOWN') {
      complete = false;
      continue;
    }
    if (!Number.isFinite(ratio) || ratio < 0) {
      complete = false;
      continue;
    }
    for (const key of keys) {
      if (overflowed.has(key)) continue;
      const nutrient = composition.nutrients[key];
      if (nutrient.state !== 'KNOWN') {
        complete = false;
        continue;
      }
      const calculated = nutrient.value * ratio;
      if (!Number.isFinite(calculated) || calculated < 0) {
        complete = false;
        continue;
      }
      const sum = (totals[key] ?? 0) + calculated;
      if (!Number.isFinite(sum)) {
        complete = false;
        delete totals[key];
        overflowed.add(key);
        continue;
      }
      totals[key] = sum;
    }
  }

  const coverage: NutritionCoverage = complete
    ? 'COMPLETA'
    : Object.keys(totals).length > 0
      ? 'PARCIAL'
      : 'NO_CALCULABLE';
  return { coverage, totals };
}
